import React, { useEffect, useState, forwardRef } from 'react';
import styled from 'styled-components'

const Space = forwardRef<HTMLDivElement, any>(({children, hasLoggedIn},ref) => {
	const [BrowserSupport, setBrowserSupport] = useState(true);

  useEffect(() => {
    const checkBrowser = () => {
      var isFirefox = typeof InstallTrigger !== 'undefined';
      if(isFirefox){setBrowserSupport(false)};
    }

    checkBrowser();
  }, [])

	return(
		<StyledSpace ref={ref} className={!BrowserSupport ? "browserFix" : ""}>{children}</StyledSpace>
	)
})

export default Space;

const StyledSpace = styled.div`
	position: relative;
	width: 100vw;
  height: 100vh;
  perspective: 2000px;

  &.browserFix{
    background-color:Grey;
  }
`